import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import BigFileView from '@bigfile/components/views/BigFileView/BigFileView.vue'

@Component({
    components: {
        BigFileView
    }

})
export default class File extends Vue { }
